// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__8SBBD","rootSmall":"AddTileButton_rootSmall__1NWRr"};